import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';
import { selectQualifications } from '../reference/survey-creation-reference.selectors';

const { selectAudience } = surveyCreationFeature;

export const selectSurveyId = createSelector(
  selectAudience,
  ({ surveyId }) => surveyId,
);

export const selectSurvey = createSelector(
  selectAudience,
  ({ survey }) => survey,
);

export const selectMetadataForm = createSelector(
  selectAudience,
  ({ metadata }) => metadata,
);

export const selectQualificationsForm = createSelector(
  selectAudience,
  ({ qualifications }) => qualifications,
);

export const selectQuotasForm = createSelector(
  selectAudience,
  ({ quotas }) => quotas,
);

export const selectSurveyFormState = createSelector(
  selectMetadataForm,
  selectQualificationsForm,
  selectQuotasForm,
  (metadata, qualifications, quotas) => ({ metadata, qualifications, quotas }),
);

export const selectError = createSelector(selectAudience, ({ error }) => error);

//SECTION SCORE
export const selectScorePercentage = createSelector(
  selectAudience,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectAudience,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectAudience,
  ({ score }) => score.error,
);
//!SECTION

//SECTION FEASIBILITY
export const selectFeasibilityTotal = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.total,
);

export const selectFeasibilityQuotaGroups = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.quotaGroups,
);

export const selectFeasibilityAudience = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.audience,
);

export const selectFeasibilityHasQuota = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.hasQuota,
);

export const selectFeasibilityLoading = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.error,
);
//!SECTION

export const selectLocationSelectionsByQualificationCode = createSelector(
  selectAudience,
  ({ locationSelectionsByQualificationCode }) =>
    locationSelectionsByQualificationCode,
);

export const selectAdvancedTargetingDefinitions = createSelector(
  selectAudience,
  ({ advancedTargetingDefinitions }) => advancedTargetingDefinitions,
);

export const selectHasHydratedAdvancedTargeting = createSelector(
  selectAudience,
  ({ hasHydratedAdvancedTargeting }) => hasHydratedAdvancedTargeting,
);

// TODO: Move this out of here when qualifications and quotas are saved in the state.
// Bundles everything a create/save API call needs beyond the metadata form itself
export const selectSurveySaveContext = createSelector(
  selectAdvancedTargetingDefinitions,
  selectLocationSelectionsByQualificationCode,
  selectQualifications,
  (definitions, locationSelectionsByQualificationCode, qualifications) => ({
    targeting: {
      definitions,
      locationSelectionsByQualificationCode,
      qualifications,
    },
  }),
);
